/** Recibe un objeto como por ejemplo una Enum y retorna un listado de objetos con value y text */
export function mapToSelect(obj: any) {
  return Object.entries(obj).map(([value, text]) => ({ text, value }));
}

export function getValue(obj: { text: string; value: string }) {
  return obj.value;
}

/** Recibe un objeto como por ejemplo una Enum y retorna un listado de objetos con value y text */
export function mapToCodeName(obj: any) {
  return Object.entries(obj).map(([code, name]) => ({ code, name }));
}
